<template>
  <div>
    <div v-if="!showPlan">
      <div class="flex sidebar-topfixpart bg-primary p-4">
        <feather-icon
          icon="ChevronLeftIcon"
          @click="handleBack"
          class="cursor-pointer text-white"
          svgClasses="w-6"
        ></feather-icon>
        <h2 class="h2-class font-semibold text-white pl-4">ADD POLL</h2>
      </div>

      <div class="p-4">
        <div class="mb-4">
          <b-input
            placeholder="Type a question"
            v-model="text"
            :value="text"
            class="form-control-muted"
          />
        </div>
        <div>
          <div
            class="flex mb-4"
            v-for="(answer, index) in Answers"
            :key="index"
          >
            <b-input
              :placeholder="`Option ${index + 1}`"
              class="form-control-muted"
              v-model="Answers[index]"
              @focus="AddNewAnswer(index)"
            />
            <base-button size="base" type="primary" @click="DeleteAnswer(index)"
              >Delete</base-button
            >
          </div>
        </div>
      </div>
      <footer class="px-4 w-full mobile-sidebarfooter mb-10">
        <base-button
          block
          type="primary"
          :disabled="!(text && Answers[0] && Answers[1])"
          class="rounded-none font-semibold"
          @click="handleChooseChannel"
          >CHOOSE CHANNEL</base-button
        >
      </footer>
    </div>
    <div class="mb-4" v-show="showPlan">
      <ChoosePlan />
    </div>
  </div>
</template>
<script>
import ChoosePlan from "./ChoosePlan.vue";
import { mapState } from "vuex";
export default {
  components: {
    ChoosePlan,
  },
  data() {
    return {
      showPlan: false,
      text: "",
      Answers: ["", ""],
    };
  },
  watch: {
    text(val) {
      this.$store.commit("posts/SET_POST", { key: "text", value: val });
    },
    Answers(val) {
      this.$store.commit("posts/SET_POST", { key: "Answers", value: val });
    },
  },
  methods: {
    handleBack() {
      this.$store.commit("posts/SET_CURRENT_PAGE", "home");
    },
    handleChooseChannel() {
      this.$store.commit("posts/SET_CURRENT_PAGE", "Choose Channel");
    },
    AddNewAnswer(index) {
      if (this.Answers.length - 1 == index) {
        this.Answers.push("");
      }
    },
    DeleteAnswer(index) {
      if ([0, 1].includes(index)) {
        return;
      }
      this.Answers = this.Answers.filter((el, ind) => ind !== index);
    },
  },
  computed: {
    ...mapState("posts", {
      currentPage: "currentPage",
      type: "type",
    }),
    title() {
      return this.type.toUpperCase();
    },
  },
};
</script>
